function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M19.552 10.018v-7.69h-2.76V.5H24.3v1.827h-2.76v7.691h-1.988z",
  fill: "#000"
});

var _ref3 = React.createElement("path", {
  d: "M23.987 3.113h1.827v1.093c.433-.928.99-1.093 1.588-1.093h.706v1.85h-.597c-.86 0-1.628.495-1.628 2.01v3.05h-1.896v-6.91zM28.968 7.49V3.114h1.89v3.95c0 .809.393 1.407 1.201 1.407.78 0 1.275-.598 1.275-1.395V3.113h1.89v6.91h-1.799v-.87c-.455.689-1.133 1.03-1.992 1.03-1.514-.006-2.465-1.047-2.465-2.692zM36.032 8.077l1.646-.376c.08.535.506.94 1.332.94.637 0 .99-.262.99-.587 0-.262-.142-.455-.797-.598l-1.081-.233c-1.384-.302-1.97-.94-1.97-2.1 0-1.185.98-2.141 2.818-2.141 1.952 0 2.738 1.173 2.818 1.941l-1.657.364c-.08-.404-.376-.848-1.201-.848-.524 0-.91.234-.91.575 0 .285.193.444.534.524l1.577.364c1.201.274 1.76.99 1.76 2.01 0 1.093-.872 2.243-2.87 2.243-2.197-.006-2.915-1.321-2.989-2.078zM45.522 10.018c-1.224 0-2.044-.677-2.044-2.02V4.763h-1.16V3.107h1.16V1.57l1.89-.546v2.083h1.395v1.657h-1.395v2.892c0 .506.262.705.769.705h.728v1.657h-1.343zM47.89.506h1.89v9.518h-1.89V.506zM55.478 3.113H57.5L54.62 12.5h-2.021l.797-2.476h-1.042l-1.901-6.911h2.02l1.424 5.345 1.582-5.345zM.573 4.673h4.435V1.132l3.54 3.54-3.54 3.536v1.81h4.298V4.673h3.945V.506H.573v4.167z",
  fill: "#000"
});

var SvgTrustly = function SvgTrustly(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 58,
    height: 13,
    viewBox: "0 0 58 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrustly, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trustly.51c0f0fc.svg";
export { ForwardRef as ReactComponent };